import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguridad-layout',
  templateUrl: './seguridad-layout.component.html',
  styleUrls: ['./seguridad-layout.component.css']
})
export class SeguridadLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
